<div [class]="field.customClass">
	<div *ngFor="let option of field.options" class="field-radio-button">
		<p-radioButton [name]="field.path ? field.path : field.Name" [value]="option.value" [formControl]="control"></p-radioButton>
		<label class="ml-2">{{ option.label }}</label>
	</div>
</div>
